import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PermissionEnum } from '@interfaces';

@Component({
  selector: 'app-cr-header',
  templateUrl: './cr-header.component.html',
  styleUrls: ['./cr-header.component.scss'],
})
export class CrHeaderComponent implements OnInit {
  @Input() isLoading = false;
  @Input() isDisabled = false;

  @Input() headingLevel: 1 | 2 | 3 | 4 | 5 | 6 | null = null;

  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'SMALL';
  @Input() showBorder?: boolean = true;

  @Input() innerHTML?: string;

  @Input() buttonText?: string;
  @Input() buttonRequiredPermissions?: PermissionEnum[] = [];
  @Input() buttonRouterLink?: any[] = [];
  @Input() buttonGoBack? = false;

  @Output() clicked = new EventEmitter<void>();

  public cssClasses: string[] = [];

  constructor() {}

  public ngOnInit() {
    this.cssClasses = [`FONT-${this.fontSize}`];
  }

  public onClick(): void {
    if (this.isLoading) {
      return;
    }
    if (this.isDisabled) {
      return;
    }

    this.clicked.emit();
  }
}
